import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface PricingTableInputPlaceholderProps {
  color?: string;
  value: string;
}

export const PricingTableInputPlaceholder: React.FC<
  PricingTableInputPlaceholderProps
> = ({ color, value }) => {
  const [styles] = useStyles();

  return (
    <View style={styles.container}>
      <Typography color={color} variant="paragraph-md">
        {value}
      </Typography>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'flex-end',
    paddingRight: theme.sk.spacing.spaceSMedium + 1, // non-editable values line up with the column's editable input values
  },
}));
